import { gql } from '@apollo/client'

export const GET_CAMPAIGN_IMPRESSIONS_BASED_ON_FREQUENCY = gql`
  query campaignEstimatedImpressionsBasedOnFrequency($campaignId: ID!) {
    campaignImpressionsBasedOnFrequency(campaignId: $campaignId) {
      impressions
    }
  }
`
